import { TextRow } from '../../TextRow'
import type { Value } from 'types'

export function CheckboxRow({ text, description, icon, tooltipProps }: Value) {
  return (
    <TextRow
      text={text}
      typography={{
        size: 'sm',
        weight: 'medium',
        className: 'text-left',
      }}
      subtitle={
        typeof description === 'string'
          ? {
              value: description,
              position: 'horizontal',
              typography: {
                className: 'text-left',
                size: 'sm',
                weight: 'regular',
              },
            }
          : undefined
      }
      icon={
        icon?.component
          ? {
              component: (
                <div className="w-6 h-6 shrink-0">{icon.component}</div>
              ),
            }
          : undefined
      }
      tooltipProps={tooltipProps}
    />
  )
}
